import GuidePage from "./GuidePage";

const chapters = [
  {
    title: "Die kurze Antwort",
    body: (
      <>
        <p>
          Für nahe Angehörige: <strong>3-5 Minuten.</strong><br />
          Für Freund:innen und weitere Familie: <strong>2-3 Minuten.</strong><br />
          Für Kolleg:innen: <strong>1-2 Minuten.</strong>
        </p>
        <p>
          Eine Trauerrede überschreitet in aller Regel keine sieben Minuten. Was länger ist, verliert
          den Raum — auch wenn es gut geschrieben ist.
        </p>
      </>
    ),
  },
  {
    title: "Wörter in Minuten übersetzen",
    body: (
      <>
        <p>Eine ruhig gesprochene Trauerrede folgt einer klaren Rechnung:</p>
        <ul className="mt-4 space-y-2 list-disc list-inside">
          <li><strong>~150 Wörter</strong> ≈ 1 Minute Sprechzeit</li>
          <li><strong>~450 Wörter</strong> ≈ 3 Minuten</li>
          <li><strong>~750 Wörter</strong> ≈ 5 Minuten</li>
          <li><strong>~1.000 Wörter</strong> ≈ 6-7 Minuten</li>
          <li><strong>~2.000 Wörter</strong> ≈ 12-14 Minuten (nur für ausführliche Würdigungen)</li>
        </ul>
        <p className="mt-6">
          Sprechen Sie den Text laut vor sich selbst — die tatsächliche Zeit ist meist länger, als
          Sie lesend schätzen. Vor allem, weil eine Trauerrede natürliche Pausen enthält.
        </p>
      </>
    ),
  },
  {
    title: "Warum kürzer meistens würdiger ist",
    body: (
      <>
        <p>
          Bei Trauerreden gilt öfter als woanders: <em>Weniger ist mehr.</em> Nicht, weil der Mensch
          weniger wert wäre — sondern weil <strong>ein Bild, das steht</strong> in einer Rede tiefer
          bleibt als zwanzig Anekdoten hintereinander.
        </p>
        <p>
          Zwei bis drei konkrete Momente, klar formuliert und ruhig gesprochen, tragen den Raum
          zuverlässiger als ein vollständiger Lebenslauf. Es ist keine Todesanzeige, die Sie halten —
          es ist eine Rede.
        </p>
      </>
    ),
  },
  {
    title: "Faustregeln zum Kürzen",
    body: (
      <>
        <ul className="space-y-3 list-disc list-inside">
          <li>Alle Sätze, die mit „Er/Sie war immer…“ beginnen — streichen oder konkretisieren.</li>
          <li>Superlative streichen: „die beste“, „der wichtigste“ — wirken schwächer als Beispiele.</li>
          <li>Zwei sehr ähnliche Anekdoten? Nehmen Sie die konkretere.</li>
          <li>Der Anlassrahmen („Wir haben uns hier versammelt…“) — meist streichbar.</li>
          <li>Danksagungen ans Publikum ans Ende, kurz halten.</li>
        </ul>
      </>
    ),
  },
];

const faq = [
  {
    q: "Wie viele Minuten sollte eine Trauerrede haben?",
    a: "Meist 3-5 Minuten für nahe Angehörige, 2-3 Minuten für Freunde und Kollegen. Sieben Minuten sollte eine Trauerrede selten überschreiten. Eine kurze, konkrete Rede trägt würdiger als eine vollständige.",
  },
  {
    q: "Wie viele Wörter sind 5 Minuten?",
    a: "Etwa 750 Wörter bei ruhigem Sprechtempo. Rechnen Sie 150 Wörter pro Minute — inklusive natürlicher Pausen kommt das gut hin.",
  },
  {
    q: "Wie viele Seiten hat eine 5-Minuten-Trauerrede?",
    a: "Etwa 2 DIN-A4-Seiten in normaler Schriftgröße (12 pt, 1,5-facher Zeilenabstand). Drucken Sie in doppelter Größe (16-18 pt) aus, damit Sie es am Trauertag ohne Brille lesen können.",
  },
  {
    q: "Muss eine Trauerrede immer kurz sein?",
    a: "Nein, es gibt Fälle für ausführlichere Würdigungen — etwa bei nahen Angehörigen mit langem, ereignisreichem Leben. Dann sind 10-14 Minuten möglich, aber selten sinnvoll.",
  },
];

const related = [
  { label: "Trauerrede schreiben — Anleitung", to: "/trauerrede-schreiben" },
  { label: "Die richtige Einleitung", to: "/trauerrede-einleitung" },
  { label: "Eine Trauerrede halten", to: "/trauerrede-halten" },
];

export default function WieLangTrauerrede() {
  return (
    <GuidePage
      slug="wie-lang-trauerrede"
      metaTitle="Wie lang sollte eine Trauerrede sein? — Antwort in Minuten & Wörtern | Oratiorede"
      metaDescription="Wie lang darf eine Trauerrede sein? Die klare Antwort: 3-5 Minuten für Angehörige. Wörter-in-Minuten-Umrechnung und Faustregeln zum Kürzen."
      eyebrow="Ratgeber · Länge einer Trauerrede"
      headline={
        <>
          Wie lang sollte eine Trauerrede sein?
          <br />
          <span className="italic text-umber">Meist kürzer, als Sie denken.</span>
        </>
      }
      intro={`Die häufigste Sorge Angehöriger ist: „zu kurz.“ Die häufigste Wahrheit erfahrener Trauerredner:innen ist: „zu lang.“ Hier die klaren Zahlen — und warum kürzer meistens würdiger ist.`}
      chapters={chapters}
      faq={faq}
      related={related}
    />
  );
}
